import { render } from "./HeroSectionStudent.vue?vue&type=template&id=10a4d47c&scoped=true"
import script from "./HeroSectionStudent.vue?vue&type=script&lang=js"
export * from "./HeroSectionStudent.vue?vue&type=script&lang=js"

import "./HeroSectionStudent.vue?vue&type=style&index=0&id=10a4d47c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a4d47c"]])

export default __exports__